// import { TAB_FINANCIAL_REPORT } from '../constants/actionTypes'

const defaultStatus = {
    title: '설정',
    tabId: 'more'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/setting.js